import { render } from "./MruAdministration.vue?vue&type=template&id=b0970144&scoped=true"
import script from "./MruAdministration.vue?vue&type=script&lang=js"
export * from "./MruAdministration.vue?vue&type=script&lang=js"

import "./MruAdministration.vue?vue&type=style&index=0&id=b0970144&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0970144"]])

export default __exports__